var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"element",staticClass:"lower-third"},[_c('div',{staticClass:"lt-box"},[_c('div',{staticClass:"text-container"},[(_vm.title.length)?_c('span',{staticClass:"lt-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('span',{staticClass:"lt-content"},[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }